import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import AutoQuery from 'servicestack/auto-query/auto-query'
import $session from 'servicestack/session'
import addressValidatorPrompt from 'webutils/address-validator-prompt'

class AddressInputPromptController {
    constructor($rootScope, $uibModalInstance, $geo, options) {
        var $ctrl = this;
        basicController($ctrl);
		var model = $ctrl.model = options.model;
		var key = $ctrl.key = options.key;
		var bus = $ctrl.bus = new ServiceBus($rootScope);
		$ctrl.bus.validationErrors = [];
		$ctrl.$uibModalInstance = $uibModalInstance;
		$ctrl.$geo = $geo;
		if (!$ctrl.model.country || $ctrl.model.country == "") $ctrl.model.country = "US";
		$ctrl.save = $ctrl.submit = function () {
			if (!$ctrl.model.address || !$ctrl.model.city || !$ctrl.model.state || !$ctrl.model.zip) return modals.alert("Please enter all address fields");
			$ctrl.validate().then(function () {
				if ($ctrl.valid) {
					$ctrl.$uibModalInstance.close($ctrl.model);
				} else {
					return modals.confirm("Address could not be verified.  Continue with address?", "Address not verified").result.then(function () {
						$ctrl.$uibModalInstance.close($ctrl.model);
					});
				}
			});
		};
    }
	validate() {
		let $ctrl = this;
		if ($ctrl.model.country === "United States" || $ctrl.model.country === "US" || $ctrl.model.country === "USA") {
			return $ctrl.$geo.validateAddress($ctrl.model, $ctrl.key).then(function (response) {
				$ctrl.ready = true;
				$ctrl.valid = response.isValid;
				$ctrl.candidates = response.candidates;
				if (response.candidates.length > 0) {
					return addressValidatorPrompt.open({ model: $ctrl.model }).then(function (address) {
						if (address.valid && address.selected) {
							$ctrl.model.address = address.selected.address;
							$ctrl.model.address2 = address.selected.address2;
							$ctrl.model.city = address.selected.city;
							$ctrl.model.state = address.selected.state;
							$ctrl.model.zip = address.selected.zip;
						}
					});
				}
			});
		} else {
			$ctrl.ready = true;
			$ctrl.valid = true;
			$ctrl.$uibModalInstance.close($ctrl.model);
		}
	}
	dismiss(reason) {
		let $ctrl = this;
		$ctrl.$uibModalInstance.dismiss(reason);
	}
}

export default AddressInputPromptController;